// Contenu produits repris fidèlement de www.maisongilles.be (pages Honda,
// Husqvarna et Robots tondeuses). Textes mot pour mot, images réelles.

export const HONDA = {
  intro1:
    "Honda est une référence mondiale, reconnue pour la qualité de ses automobiles et de ses équipements motorisés.",
  intro2:
    "Spécialiste des outils de jardin, Honda propose une gamme complète, alliant équipements thermiques et à batterie, pour répondre à tous vos besoins d'entretien extérieur.",
  miimoTitre: 'Une tonte simple et efficace',
  miimoTexte:
    "Les robots tondeuses Honda Miimo, lancés en 2012, se distinguent par leur fiabilité, leur silence de fonctionnement et leur technologie de mulching qui restitue naturellement les brins d'herbe au sol.",
  lienOfficiel: 'https://www.fr.honda.be/lawn-and-garden.html',
  categories: [
    { nom: 'Tondeuses', img: '/img/honda-tondeuse.webp' },
    { nom: 'Robots tondeuses', img: '/img/honda-miimo.png' },
    { nom: 'Tracteurs', img: '/img/honda-tracteur.png' },
    { nom: 'Taille-haies', img: '/img/honda-taille-haie.webp' },
    { nom: 'Souffleurs', img: '/img/honda-souffleur.webp' },
    { nom: 'Tronçonneuses', img: '/img/honda-tronconneuse.png' },
    { nom: 'Multi-outils', img: '/img/honda-multi-outils.png' },
    { nom: 'Débroussailleuses', img: '/img/honda-debroussailleuse.png' },
    { nom: 'Coupe bordures', img: '/img/honda-coupe-bordure.png' },
    { nom: 'Motoculteurs', img: '/img/honda-motoculteur.png' },
    { nom: 'Débroussailleuses sur roues', img: '/img/honda-debrouss-roues.png' },
    { nom: 'Groupes électrogènes', img: '/img/honda-groupe-electrogene.png' },
  ],
}

export const HUSQVARNA = {
  intro:
    "Husqvarna est notre marque phare, forte de nombreuses années d'expertise dans les équipements d'entretien extérieur. Innovante et reconnue mondialement, elle s'est imposée comme leader sur le marché des robots tondeuses Automower, tout en proposant une gamme complète d'outils thermiques et à batterie.",
  automowerTitre: 'Une tonte simple et efficace',
  automowerTexte:
    "Les robots tondeuses Husqvarna Automower® dominent le marché depuis plus de trente ans grâce à leur fiabilité, leur autonomie et leurs innovations technologiques.",
  lienOfficiel: 'https://www.husqvarna.com/be-fr/',
  categories: [
    { nom: 'Tondeuse', img: '/img/husq-tondeuse.png' },
    { nom: 'Robot tondeuse', img: '/img/husq-robot.png' },
    { nom: 'Tracteur', img: '/img/husq-tracteur.png' },
    { nom: 'Taille-haie', img: '/img/husq-taille-haie.png' },
    { nom: 'Débroussailleuse', img: '/img/husq-debroussailleuse.png' },
    { nom: 'Coupe bordure', img: '/img/husq-coupe-bordure.png' },
    { nom: 'Tronçonneuse', img: '/img/husq-tronconneuse.png' },
    { nom: 'Élagueuse', img: '/img/husq-elagueuse.png' },
    { nom: 'Souffleur', img: '/img/husq-souffleur.png' },
  ],
}

// Catalogue robots tondeuses Husqvarna Automower (modèles + prix réels du site).
export const CATALOGUE_ROBOTS = [
  { modele: '308V', prix: '1 399 €' },
  { modele: '312V', prix: '1 699 €' },
  { modele: '305 NERA', prix: '2 199 €' },
  { modele: '310 NERA', prix: '2 499 €' },
  { modele: '320 NERA', prix: '3 299 €' },
  { modele: '405VE NERA', prix: '2 649 €' },
  { modele: '410VE NERA', prix: '3 199 €' },
  { modele: '430V NERA', prix: '4 299 €' },
  { modele: '450V NERA', prix: '5 499 €' },
  { modele: '435X AWD NERA', prix: '5 999 €' },
]

export const ACCOMPAGNEMENT = [
  {
    titre: 'Conseils',
    texte:
      "Nous vous aidons à choisir la tondeuse la plus adaptée à votre jardin et à ses besoins, en tenant compte de la surface, du type de terrain et des contraintes d'usage.",
  },
  {
    titre: 'Installation à domicile',
    texte:
      "Nous prenons en charge l'installation complète de votre robot tondeuse et vous formons à son utilisation, pour un fonctionnement optimal et votre tranquillité d'esprit.",
  },
  {
    titre: 'Entretien',
    texte:
      'Nous réalisons un entretien annuel de votre robot tondeuse et vérifions ses performances, pour garantir sa longévité et votre sérénité.',
  },
]
